import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useResetPasswordComplete } from "./hook";

export const ResetPasswordCompletePage: React.FC = () => {
  const { handleResetPasswordComplete } = useResetPasswordComplete();

  return (
    <CardTemplate title="パスワード再設定完了">
      <StyledTextContainer>
        パスワード設定が完了しました。下部ボタンよりログイン画面へ遷移し、ログインを行ってください。
      </StyledTextContainer>

      <Button
        text="ログインへ"
        variant="filled"
        onClick={handleResetPasswordComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
